<template>
    <ion-row v-if="isLoyaltyMember" size="12" class="rewards-container d-flex ion-justify-content-center" style="padding-top: 15px; background-color: #f0efed" data-cy="rewards-container">
        <ion-col size="12" class="ion-text-center py-0" data-cy="rewards-message">
            <ion-text class="interstate-bold color-secondary" style="font-size: 1.2em"> Welcome{{ account.firstName ? `, ${account.firstName}` : '' }}! </ion-text>

            <ion-text v-if="isLoyaltyProcessing" class="interstate-bold color-primary"> You have <ion-spinner color="primary" name="lines-small" style="margin-bottom: -8px" /> Points.</ion-text>
            <ion-text v-else class="interstate-bold color-primary"> You have {{ pointsBalance }} Points.</ion-text>
        </ion-col>
        <ion-col size="12" class="d-flex ion-justify-content-center mb-8">
            <content-block slug="home-page-rewards-banner" />
        </ion-col>
    </ion-row>

    <ion-row v-else>
        <ion-col size="12" class="d-flex ion-justify-content-center mb-8">
            <content-block slug="home-page-nonmember-banner" />
        </ion-col>
    </ion-row>
</template>

<script lang="ts">
// TODO: Update content-block slugs to match what marketing would like
import { computed, defineComponent } from 'vue';
import { useRouter } from 'vue-router';

import { IonCol, IonRow, IonText, IonSpinner } from '@ionic/vue';
import ContentBlock from '@/components/contentBlock.vue';
import { useStore } from 'vuex';
import { Account } from '@/models/account/authModels';
import useShowRewards from '@/composables/useShowRewards';

export default defineComponent({
    setup() {
        const router = useRouter();
        const store = useStore();
        const { isLoyaltyMember } = useShowRewards();

        const account = computed((): Account => store.getters.getAccount);
        const pointsBalance = computed(() => (account.value ? account.value.rewardSummary?.balance : 0));
        const isLoyaltyProcessing = computed(() => store.getters.isLoyaltyProcessing);

        return { router, account, pointsBalance, isLoyaltyMember, isLoyaltyProcessing };
    },
    components: { IonCol, IonRow, IonText, ContentBlock, IonSpinner },
});
</script>
